define('models/invite/invite',[
    "backbone"
], function (Backbone) {

    var Invitation = Backbone.Model.extend({
        url: function () {
            return pf.consumerURL + "/Invitation";
        },
        initialize: function (options) {
            options || (options = {});

            this.firstName = options.FN;
            this.lastName = options.LN;
            this.email = options.E;
            this.invitedDT = options.IDT;
            this.acceptedDT = options.ADT;
        },
        parse: function (data) {
            var response = {};
            response.firstName = data.FN;
            response.lastName = data.LN;
            response.email = data.E;
            response.invitedDT = data.IDT;
            response.acceptedDT = data.ADT;
            return response;
        },
        save: function (attributes, options) {
            options = options || {};
            attributes = attributes || {};;

            var data = {};
            data.firstName = this.FN;
            data.lastName = this.LN;
            data.email = this.E;
            data.invitedDT = this.IDT;
            data.acceptedDT = this.ADT;

            this.attributes = data;

            return Backbone.Model.prototype.save.call(this, this.attributes, options);
        }
    });

    return Invitation;
});

